export const idlFactory = ({ IDL }) => {
  const ProjectApiKey = IDL.Text;
  const ParticipantName = IDL.Text;
  const AddNewViewerParticipantError = IDL.Variant({
    'validationError' : IDL.Text,
    'notAccess' : IDL.Null,
    'projectNotFound' : IDL.Null,
    'participantExists' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const AddNewViewerParticipantResult = IDL.Variant({
    'ok' : IDL.Null,
    'err' : AddNewViewerParticipantError,
  });
  const AccessToken = IDL.Text;
  const Range = IDL.Record({ 'start' : IDL.Nat32, 'length' : IDL.Nat32 });
  const LifecycleChartRequestChunkParams = IDL.Record({
    'partitionsRange' : Range,
    'lastNDays' : IDL.Nat32,
  });
  const ChartLastNIntervalData = IDL.Record({
    'data' : IDL.Vec(IDL.Int32),
    'intervalStartTimeSec' : IDL.Nat32,
  });
  const ProjectDashboardResultData = IDL.Record({
    'dau' : ChartLastNIntervalData,
    'mau' : ChartLastNIntervalData,
    'wau' : ChartLastNIntervalData,
    'projectUsers' : IDL.Int32,
    'newUsers' : ChartLastNIntervalData,
  });
  const AnalyticsReducerApiError = IDL.Variant({
    'wrongApiKey' : IDL.Null,
    'notFound' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const GetProjectDashboardResult = IDL.Variant({
    'ok' : ProjectDashboardResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectDashboardChunk = IDL.Func(
      [AccessToken, LifecycleChartRequestChunkParams],
      [GetProjectDashboardResult],
      ['query'],
    );
  const EventDescription = IDL.Record({ 'name' : IDL.Text });
  const EventQuery = IDL.Record({ 'eventDescription' : EventDescription });
  const QueryPeriod = IDL.Variant({ 'last' : IDL.Nat32 });
  const QueryPartitionRange = IDL.Record({
    'start' : IDL.Nat32,
    'length' : IDL.Nat32,
  });
  const EventUniquesChartResultData = IDL.Record({
    'uniques' : ChartLastNIntervalData,
  });
  const GetProjectEventUniquesResult = IDL.Variant({
    'ok' : EventUniquesChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectEventUniquesMonth = IDL.Func(
      [AccessToken, EventQuery, QueryPeriod, QueryPartitionRange],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const QueryEventVariant = IDL.Variant({
    'event' : EventQuery,
    'session' : IDL.Null,
    'anyEvent' : IDL.Null,
    'newUser' : IDL.Null,
  });
  const PeriodType = IDL.Variant({ 'last' : IDL.Nat32 });
  const EventUniquesGranularity = IDL.Variant({
    'monthly' : IDL.Null,
    'daily' : IDL.Null,
    'weekly' : IDL.Null,
  });
  const EventUniquesChartRequestChunkParams = IDL.Record({
    'periodType' : PeriodType,
    'granularity' : EventUniquesGranularity,
    'partitionsRange' : Range,
  });
  const GetProjectEventUniques = IDL.Func(
      [AccessToken, QueryEventVariant, EventUniquesChartRequestChunkParams],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const LifecycleRawData = IDL.Record({
    'churnedUsersCohort' : IDL.Vec(IDL.Int32),
    'resurrectedUsers' : IDL.Vec(IDL.Int32),
    'newUsers' : IDL.Vec(IDL.Int32),
    'churnedUsers' : IDL.Vec(IDL.Int32),
    'currentUsers' : IDL.Vec(IDL.Int32),
  });
  const LifecycleChartResultData = IDL.Record({
    'intervalStartTimeSec' : IDL.Nat32,
    'rawData' : LifecycleRawData,
  });
  const GetProjectLifecycleResult = IDL.Variant({
    'ok' : LifecycleChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectLifecycleChunkWeek = IDL.Func(
      [AccessToken, LifecycleChartRequestChunkParams],
      [GetProjectLifecycleResult],
      ['query'],
    );
  const IsAnyProjectAnalyticsResult = IDL.Variant({
    'ok' : IDL.Bool,
    'err' : AnalyticsReducerApiError,
  });
  const IsAnyProjectAnalytics = IDL.Func(
      [AccessToken],
      [IsAnyProjectAnalyticsResult],
      ['query'],
    );
  const GetProjectAnyEventUniquesWeek = IDL.Func(
      [AccessToken, QueryPeriod, QueryPartitionRange],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const GetProjectAnyEventUniquesMonth = IDL.Func(
      [AccessToken, QueryPeriod, QueryPartitionRange],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const GetProjectEventUniquesDay = IDL.Func(
      [AccessToken, EventQuery, QueryPeriod],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const RetentionTypeNDay = IDL.Record({});
  const RetentionTypeNWeek = IDL.Record({});
  const RetentionTypeNMonth = IDL.Record({});
  const RetentionType = IDL.Variant({
    'nDay' : RetentionTypeNDay,
    'nWeek' : RetentionTypeNWeek,
    'nMonth' : RetentionTypeNMonth,
  });
  const RetentionChartRequestChunkParamsNew = IDL.Record({
    'periodType' : PeriodType,
    'partitionsRange' : Range,
    'retentionType' : RetentionType,
  });
  const RetentionChartResultData = IDL.Record({
    'retentionPeriods' : IDL.Vec(IDL.Nat32),
    'retention' : IDL.Vec(IDL.Vec(IDL.Int32)),
    'intervalStartTimeSec' : IDL.Nat32,
  });
  const GetProjectRetentionResult = IDL.Variant({
    'ok' : RetentionChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectRetentionChunkNew = IDL.Func(
      [
        AccessToken,
        IDL.Vec(QueryEventVariant),
        IDL.Vec(QueryEventVariant),
        RetentionChartRequestChunkParamsNew,
      ],
      [GetProjectRetentionResult],
      ['query'],
    );
  const GetProjectEventUniquesWeek = IDL.Func(
      [AccessToken, EventQuery, QueryPeriod, QueryPartitionRange],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const GetProjectAnyEventUniquesDay = IDL.Func(
      [AccessToken, QueryPeriod],
      [GetProjectEventUniquesResult],
      ['query'],
    );
  const GetProjectLifecycleChunkMonth = IDL.Func(
      [AccessToken, LifecycleChartRequestChunkParams],
      [GetProjectLifecycleResult],
      ['query'],
    );
  const GetProjectEventNamesResult = IDL.Variant({
    'ok' : IDL.Vec(IDL.Text),
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectEventNames = IDL.Func(
      [AccessToken],
      [GetProjectEventNamesResult],
      ['query'],
    );
  const StickinessChartRequestChunkParams = IDL.Record({
    'partitionsRange' : Range,
    'lastNDays' : IDL.Nat32,
  });
  const StickinessChartResultData = IDL.Record({
    'chartData' : IDL.Vec(IDL.Vec(IDL.Int32)),
    'periods' : IDL.Vec(IDL.Nat32),
    'intervalStartTimeSec' : IDL.Nat32,
  });
  const GetProjectStickinessResult = IDL.Variant({
    'ok' : StickinessChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectStickinessChunk = IDL.Func(
      [AccessToken, StickinessChartRequestChunkParams],
      [GetProjectStickinessResult],
      ['query'],
    );
  const FunnelStepUniques = IDL.Vec(IDL.Nat32);
  const FunnelChartResultData = IDL.Record({
    'overtime' : IDL.Vec(FunnelStepUniques),
    'classic' : FunnelStepUniques,
    'intervalStartTimeSec' : IDL.Nat32,
  });
  const GetProjectFunnelResult = IDL.Variant({
    'ok' : FunnelChartResultData,
    'err' : AnalyticsReducerApiError,
  });
  const GetProjectFunnelChunkDay = IDL.Func(
      [
        AccessToken,
        IDL.Vec(QueryEventVariant),
        PeriodType,
        QueryPartitionRange,
      ],
      [GetProjectFunnelResult],
      ['query'],
    );
  const GetProjectLifecycleChunkDay = IDL.Func(
      [AccessToken, LifecycleChartRequestChunkParams],
      [GetProjectLifecycleResult],
      ['query'],
    );
  const RetentionChartRequestChunkParams = IDL.Record({
    'partitionsRange' : Range,
    'lastNDays' : IDL.Nat32,
  });
  const GetProjectRetentionChunk = IDL.Func(
      [AccessToken, RetentionChartRequestChunkParams],
      [GetProjectRetentionResult],
      ['query'],
    );
  const AnalyticsReducerApi = IDL.Record({
    'getProjectDashboardChunk' : GetProjectDashboardChunk,
    'getProjectEventUniquesMonth' : GetProjectEventUniquesMonth,
    'getProjectEventUniques' : GetProjectEventUniques,
    'getProjectLifecycleChunkWeek' : GetProjectLifecycleChunkWeek,
    'isAnyProjectAnalytics' : IsAnyProjectAnalytics,
    'getProjectAnyEventUniquesWeek' : GetProjectAnyEventUniquesWeek,
    'getProjectAnyEventUniquesMonth' : GetProjectAnyEventUniquesMonth,
    'getProjectEventUniquesDay' : GetProjectEventUniquesDay,
    'getProjectRetentionChunkNew' : GetProjectRetentionChunkNew,
    'getProjectEventUniquesWeek' : GetProjectEventUniquesWeek,
    'getProjectAnyEventUniquesDay' : GetProjectAnyEventUniquesDay,
    'getProjectLifecycleChunkMonth' : GetProjectLifecycleChunkMonth,
    'getProjectEventNames' : GetProjectEventNames,
    'getProjectStickinessChunk' : GetProjectStickinessChunk,
    'getProjectFunnelChunkDay' : GetProjectFunnelChunkDay,
    'getProjectLifecycleChunkDay' : GetProjectLifecycleChunkDay,
    'getProjectRetentionChunk' : GetProjectRetentionChunk,
  });
  const ManagementConfigurationRequest = IDL.Variant({
    'setAnalyticsReducerApi' : AnalyticsReducerApi,
    'setAnalyticsReducerApis' : IDL.Vec(AnalyticsReducerApi),
  });
  const Result = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
  const ProjectName = IDL.Text;
  const CreateProjectError = IDL.Variant({
    'validationError' : IDL.Text,
    'temporarilyUnavailable' : IDL.Null,
    'projectCountLimit' : IDL.Null,
  });
  const CreateProjectResult = IDL.Variant({
    'ok' : ProjectApiKey,
    'err' : CreateProjectError,
  });
  const SdkVersion = IDL.Nat32;
  const AnalyticsReducer = IDL.Record({
    'api' : AnalyticsReducerApi,
    'accessToken' : AccessToken,
  });
  const GetAnalyticsReducerApiResultError = IDL.Variant({
    'notAccess' : IDL.Null,
    'notFound' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const GetAnalyticsReducerApiResult = IDL.Variant({
    'ok' : AnalyticsReducer,
    'err' : GetAnalyticsReducerApiResultError,
  });
  const AnalyticsReducers = IDL.Record({
    'apis' : IDL.Vec(AnalyticsReducerApi),
    'accessToken' : AccessToken,
  });
  const GetAnalyticsReducerApisResult = IDL.Variant({
    'ok' : AnalyticsReducers,
    'err' : GetAnalyticsReducerApiResultError,
  });
  const GetLogMessagesFilter = IDL.Record({
    'analyzeCount' : IDL.Nat32,
    'messageRegex' : IDL.Opt(IDL.Text),
    'messageContains' : IDL.Opt(IDL.Text),
  });
  const Nanos = IDL.Nat64;
  const GetLogMessagesParameters = IDL.Record({
    'count' : IDL.Nat32,
    'filter' : IDL.Opt(GetLogMessagesFilter),
    'fromTimeNanos' : IDL.Opt(Nanos),
  });
  const GetLatestLogMessagesParameters = IDL.Record({
    'upToTimeNanos' : IDL.Opt(Nanos),
    'count' : IDL.Nat32,
    'filter' : IDL.Opt(GetLogMessagesFilter),
  });
  const CanisterLogRequest = IDL.Variant({
    'getMessagesInfo' : IDL.Null,
    'getMessages' : GetLogMessagesParameters,
    'getLatestMessages' : GetLatestLogMessagesParameters,
  });
  const CanisterLogFeature = IDL.Variant({
    'filterMessageByContains' : IDL.Null,
    'filterMessageByRegex' : IDL.Null,
  });
  const CanisterLogMessagesInfo = IDL.Record({
    'features' : IDL.Vec(IDL.Opt(CanisterLogFeature)),
    'lastTimeNanos' : IDL.Opt(Nanos),
    'count' : IDL.Nat32,
    'firstTimeNanos' : IDL.Opt(Nanos),
  });
  const LogMessagesData = IDL.Record({
    'timeNanos' : Nanos,
    'message' : IDL.Text,
  });
  const CanisterLogMessages = IDL.Record({
    'data' : IDL.Vec(LogMessagesData),
    'lastAnalyzedMessageTimeNanos' : IDL.Opt(Nanos),
  });
  const CanisterLogResponse = IDL.Variant({
    'messagesInfo' : CanisterLogMessagesInfo,
    'messages' : CanisterLogMessages,
  });
  const MetricsGranularity = IDL.Variant({
    'hourly' : IDL.Null,
    'daily' : IDL.Null,
  });
  const GetMetricsParameters__1 = IDL.Record({
    'dateToMillis' : IDL.Nat,
    'granularity' : MetricsGranularity,
    'dateFromMillis' : IDL.Nat,
  });
  const UpdateCallsAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterHeapMemoryAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterCyclesAggregatedData = IDL.Vec(IDL.Nat64);
  const CanisterMemoryAggregatedData = IDL.Vec(IDL.Nat64);
  const HourlyMetricsData = IDL.Record({
    'updateCalls' : UpdateCallsAggregatedData,
    'canisterHeapMemorySize' : CanisterHeapMemoryAggregatedData,
    'canisterCycles' : CanisterCyclesAggregatedData,
    'canisterMemorySize' : CanisterMemoryAggregatedData,
    'timeMillis' : IDL.Int,
  });
  const NumericEntity = IDL.Record({
    'avg' : IDL.Nat64,
    'max' : IDL.Nat64,
    'min' : IDL.Nat64,
    'first' : IDL.Nat64,
    'last' : IDL.Nat64,
  });
  const DailyMetricsData = IDL.Record({
    'updateCalls' : IDL.Nat64,
    'canisterHeapMemorySize' : NumericEntity,
    'canisterCycles' : NumericEntity,
    'canisterMemorySize' : NumericEntity,
    'timeMillis' : IDL.Int,
  });
  const CanisterMetricsData = IDL.Variant({
    'hourly' : IDL.Vec(HourlyMetricsData),
    'daily' : IDL.Vec(DailyMetricsData),
  });
  const CanisterMetrics__1 = IDL.Record({ 'data' : CanisterMetricsData });
  const StatusRequest = IDL.Record({
    'memory_size' : IDL.Bool,
    'cycles' : IDL.Bool,
    'heap_memory_size' : IDL.Bool,
  });
  const GetMetricsParameters = IDL.Record({
    'dateToMillis' : IDL.Nat,
    'granularity' : MetricsGranularity,
    'dateFromMillis' : IDL.Nat,
  });
  const MetricsRequest = IDL.Record({ 'parameters' : GetMetricsParameters });
  const GetInformationRequest = IDL.Record({
    'status' : IDL.Opt(StatusRequest),
    'metrics' : IDL.Opt(MetricsRequest),
    'version' : IDL.Bool,
  });
  const StatusResponse = IDL.Record({
    'memory_size' : IDL.Opt(IDL.Nat64),
    'cycles' : IDL.Opt(IDL.Nat64),
    'heap_memory_size' : IDL.Opt(IDL.Nat64),
  });
  const CanisterMetrics = IDL.Record({ 'data' : CanisterMetricsData });
  const MetricsResponse = IDL.Record({ 'metrics' : IDL.Opt(CanisterMetrics) });
  const GetInformationResponse = IDL.Record({
    'status' : IDL.Opt(StatusResponse),
    'metrics' : IDL.Opt(MetricsResponse),
    'version' : IDL.Opt(IDL.Nat),
  });
  const ProjectView = IDL.Record({
    'projectName' : ProjectName,
    'projectApiKey' : ProjectApiKey,
    'createdTimeSec' : IDL.Nat32,
  });
  const GetParticipantProjectsError = IDL.Variant({
    'temporarilyUnavailable' : IDL.Null,
  });
  const GetParticipantProjectsResult = IDL.Variant({
    'ok' : IDL.Vec(ProjectView),
    'err' : GetParticipantProjectsError,
  });
  const ProjectRole = IDL.Variant({
    'admin' : IDL.Null,
    'owner' : IDL.Null,
    'viewer' : IDL.Null,
  });
  const ParticipantView = IDL.Record({
    'principal' : IDL.Principal,
    'name' : ParticipantName,
    'role' : ProjectRole,
    'createdTimeSec' : IDL.Nat32,
  });
  const GetProjectParticipantsError = IDL.Variant({
    'notAccess' : IDL.Null,
    'projectNotFound' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const GetProjectParticipantsResult = IDL.Variant({
    'ok' : IDL.Vec(ParticipantView),
    'err' : GetProjectParticipantsError,
  });
  const MetricValue = IDL.Variant({ 'count' : IDL.Int, 'gauge' : IDL.Nat });
  const MetricLabel = IDL.Record({ 'value' : IDL.Text, 'name' : IDL.Text });
  const MetricData = IDL.Record({
    'metricValue' : MetricValue,
    'labels' : IDL.Opt(IDL.Vec(MetricLabel)),
  });
  const MetricType = IDL.Variant({ 'counter' : IDL.Null, 'gauge' : IDL.Null });
  const MetricsData = IDL.Record({
    'data' : IDL.Vec(MetricData),
    'help' : IDL.Text,
    'name' : IDL.Text,
    'metricType' : MetricType,
  });
  const RemoveParticipantError = IDL.Variant({
    'notAccess' : IDL.Null,
    'projectNotFound' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
    'participantNotFound' : IDL.Null,
  });
  const RemoveParticipantResult = IDL.Variant({
    'ok' : IDL.Null,
    'err' : RemoveParticipantError,
  });
  const CollectMetricsRequestType = IDL.Variant({
    'force' : IDL.Null,
    'normal' : IDL.Null,
  });
  const UpdateInformationRequest = IDL.Record({
    'metrics' : IDL.Opt(CollectMetricsRequestType),
  });
  const UpdateParticipantNameError = IDL.Variant({
    'validationError' : IDL.Text,
    'notAccess' : IDL.Null,
    'projectNotFound' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
    'participantNotFound' : IDL.Null,
  });
  const UpdateParticipantNameResult = IDL.Variant({
    'ok' : IDL.Null,
    'err' : UpdateParticipantNameError,
  });
  const UpdateProjectNameError = IDL.Variant({
    'validationError' : IDL.Text,
    'notAccess' : IDL.Null,
    'projectNotFound' : IDL.Null,
    'temporarilyUnavailable' : IDL.Null,
  });
  const UpdateProjectNameResult = IDL.Variant({
    'ok' : IDL.Null,
    'err' : UpdateProjectNameError,
  });
  return IDL.Service({
    'addNewViewerParticipant' : IDL.Func(
        [ProjectApiKey, IDL.Text, ParticipantName],
        [AddNewViewerParticipantResult],
        [],
      ),
    'collectCanisterMetrics' : IDL.Func([], [], []),
    'configure' : IDL.Func(
        [IDL.Vec(ManagementConfigurationRequest)],
        [Result],
        [],
      ),
    'createProject' : IDL.Func([ProjectName], [CreateProjectResult], []),
    'getAnalyticsReducerApi' : IDL.Func(
        [SdkVersion, ProjectApiKey],
        [GetAnalyticsReducerApiResult],
        ['query'],
      ),
    'getAnalyticsReducerApis' : IDL.Func(
        [SdkVersion, ProjectApiKey],
        [GetAnalyticsReducerApisResult],
        ['query'],
      ),
    'getCanisterLog' : IDL.Func(
        [IDL.Opt(CanisterLogRequest)],
        [IDL.Opt(CanisterLogResponse)],
        ['query'],
      ),
    'getCanisterMetrics' : IDL.Func(
        [GetMetricsParameters__1],
        [IDL.Opt(CanisterMetrics__1)],
        ['query'],
      ),
    'getCanistergeekInformation' : IDL.Func(
        [GetInformationRequest],
        [GetInformationResponse],
        ['query'],
      ),
    'getInformation' : IDL.Func([], [IDL.Text], []),
    'getMGTInformation' : IDL.Func([], [IDL.Text], []),
    'getParticipantProjects' : IDL.Func(
        [],
        [GetParticipantProjectsResult],
        ['query'],
      ),
    'getProjectParticipants' : IDL.Func(
        [ProjectApiKey],
        [GetProjectParticipantsResult],
        ['query'],
      ),
    'metrics' : IDL.Func([IDL.Text], [IDL.Vec(MetricsData)], []),
    'removeParticipant' : IDL.Func(
        [ProjectApiKey, IDL.Text],
        [RemoveParticipantResult],
        [],
      ),
    'updateCanistergeekInformation' : IDL.Func(
        [UpdateInformationRequest],
        [],
        [],
      ),
    'updateParticipantName' : IDL.Func(
        [ProjectApiKey, IDL.Text, ParticipantName],
        [UpdateParticipantNameResult],
        [],
      ),
    'updateProjectName' : IDL.Func(
        [ProjectApiKey, ProjectName],
        [UpdateProjectNameResult],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
